import React, { useState } from "react";

const SortOption = ({getSortValue}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedSort, setSelectedSort] = useState("Select...");

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleSortChange = (sortOption) => {
    setSelectedSort(sortOption);
    if(sortOption === 'Newest'){
      getSortValue('newest')
    }
    if(sortOption === 'Price: Low to High'){
      getSortValue('LtoH')
    }
    if(sortOption === 'Price: High to Low'){
      getSortValue('HtoL')
    }
    setIsOpen(false);
  };


  return (
    <div className="font-twentieth-century">
      <div className="relative">
        <div className="flex">
          <p className="mr-2 mt-2 text-gray-400 text-md">Sort By:</p>
          <button
            onClick={toggleDropdown}
            className="text-black border flex justify-between border-gray-300 px-4 py-2 rounded focus:outline-none md:w-48 text-left"
          >
            {selectedSort}
            <svg
              className={`w-4 h-4 ml-2 mt-1 transition-transform ${
                isOpen ? "transform rotate-180" : ""
              }`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </button>
        </div>
        {isOpen && (
          <div className="absolute right-0 mb-2 w-48 bg-white border border-gray-200 rounded shadow-lg z-10 mt-1">
            <ul>
              <li
                className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                onClick={() => handleSortChange("Newest")}
              >
                Newest
              </li>
              <li
                className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                onClick={() => handleSortChange("Price: Low to High")}
              >
                Price: Low to High
              </li>
              <li
                className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                onClick={() => handleSortChange("Price: High to Low")}
              >
                Price: High to Low
              </li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default SortOption;
